import { isSupportAvif, isSupportWebp, SupportedWritingFormats } from "./format-support-detection";
// 处理图片格式
export function handleImageFormat(format) {
  if (!format) return undefined;
  var webpok = isSupportWebp();
  var avifok = isSupportAvif();

  // 自动格式
  if (format === 'auto') {
    if (avifok) return 'avif';
    if (webpok) return 'webp';
    return undefined;
  }

  // 指定格式
  if (format === 'avif') return avifok ? 'avif' : undefined;
  if (format === 'webp') return webpok ? 'webp' : undefined;

  // 支持的格式
  if (SupportedWritingFormats.includes(format)) {
    return format;
  }

  // 不支持的格式
  console.error("\u4E0D\u652F\u6301\u7684\u56FE\u7247\u683C\u5F0F\uFF1A".concat(format));
  return undefined;
}